import {useDispatch, useSelector} from "react-redux";
import {useFetch} from "../../../services/useFetch";
import {API} from "../../../services/api";
import {
    FIELD_LIST_MAIN_EVENTS_ITEM,
    FIELD_LIST_GENERAL_MAIN_EVENTS,
    FIELD_NAME_GENERAL_MAIN_EVENTS
} from "../../../utils/input-field-list-static-page";
import {convertErrorMessage, randomCode} from "../../../utils/general-variable";
import {cloneDeep} from "lodash";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../../reducers/tools.reducer";
import React, {useEffect} from "react";
import Item from "../../avoskin-trail-run/main-events/item";
import FormItemComponent from "../../../components/static-page/form-item.component";
import {
    setAvoskinTrailRunErrorMessage,
    setAvoskinTrailRunMainEventsDetail
} from "../../../reducers/avoksin-trail-run.reducer";

const MainEvents = () => {
    const dispatch = useDispatch()
    const {mainEventsDetail, avoskinTrailRunErrorMessage} = useSelector(state => state.avoskinTrailRunReducer)
    const {fetching: getMainEvents} = useFetch(API.AVOSKIN_TRAIL_RUN_GET_MAIN_EVENTS)
    const {fetching: updateMainEvents, isLoading} = useFetch(API.AVOSKIN_TRAIL_RUN_UPDATE_MAIN_EVENTS)
    const itemList = [...mainEventsDetail.images]
    let fieldListGeneral = FIELD_LIST_GENERAL_MAIN_EVENTS
    let fieldListItem = FIELD_LIST_MAIN_EVENTS_ITEM
    let showMainEvents = {
        label: 'Main Events',
        key: 'show_main_events',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setAvoskinTrailRunMainEventsDetail({[key]: value}))
    }

    const addItemHandler = () => {
        itemList.push({
            id: randomCode(5, 1, 'image').toString(),
            title: null,
            description: null,
            image_url: null
        })
        dispatch(setAvoskinTrailRunMainEventsDetail({images: itemList}))
    }

    const itemListConstruct = () => {
        const itemListCopy = cloneDeep(mainEventsDetail.images)
        const result = itemListCopy?.map((item, index) => {
            if(!Number(item.id)) delete item.id
            item.sequence = index
            return item
        })
        return result
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        const dataItemList = itemListConstruct()
        const dataMainEvents = {...mainEventsDetail, images: dataItemList}
        updateMainEvents(dataMainEvents).then(response => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Main Events Updated'))
            dispatch(setAvoskinTrailRunMainEventsDetail({...response?.data, delete_ids: []}))
        }).catch(err => {
            dispatch(setAvoskinTrailRunErrorMessage(convertErrorMessage(err, {}, FIELD_NAME_GENERAL_MAIN_EVENTS)))
        })
    }

    useEffect(() => {
        getMainEvents().then(response => {
            if (response?.data?.images?.length > 0) {
                dispatch(setAvoskinTrailRunMainEventsDetail({...response?.data, delete_ids: []}))
            } else {
                const data = response?.data
                delete data?.images
                dispatch(setAvoskinTrailRunMainEventsDetail({...data, delete_ids: []}))
            }
        })

        return () => {
            dispatch(setAvoskinTrailRunErrorMessage({}))
        }
    }, [])

    return (
        <FormItemComponent
            data={mainEventsDetail}
            switchToggleField={showMainEvents}
            fieldListGeneral={fieldListGeneral}
            itemList={itemList}
            content={(index) => <Item fieldList={fieldListItem} index={index}/>}
            onChange={onChange}
            setDataList={setAvoskinTrailRunMainEventsDetail}
            deleteList={mainEventsDetail.delete_ids}
            objectName={'images'}
            addItemHandler={addItemHandler}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={avoskinTrailRunErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default MainEvents
